import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
let template = require('./admin-nav-bar.html');

class AdminNavBarComponent extends ComponentRegistration {

    constructor() {
        super('adminNavBar', {
            controller: AdminNavBarController,
            templateUrl: template,
            controllerAs: 'adminNavBar',
            bindings: {
                selected: '@'
            }
        });
    }
}



interface INavBarController {
    isSelected(index): Boolean;
    onNavClick(index): void;
}

class AdminNavBarController implements INavBarController {
    public static $inject: Array<string> = ['$rootRouter'];

    //private fields
 
    //bindings
    private selected: any;

    constructor(private $rootRouter:ng.Router) {
        console.log('AdminNavBarController activated');
    }

    public $onInit(): void {
        console.log('AdminNavBarController loaded');
    }

    public isSelected(index): Boolean {
        return index === this.selected;
    }

    public onNavClick(index): void {
        this.selected = index;
        this.$rootRouter.navigate([index]);
    }

}

let adminNbarComponent = new AdminNavBarComponent();
export default adminNbarComponent;
export { adminNbarComponent as AdminNavBarComponent, INavBarController, AdminNavBarController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/user-controls/admin-nav-bar.ts